import globals from "imports/globals";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        if (globals.debug) console.log("component-ui initialized");
        $(".button-top").on("click", function () {
            window.scrollTo(0, 0);
            history.pushState("", document.title, window.location.pathname + window.location.search);
        });
    });
})();

export default component;
